<template>
	<div class="top-menu-controls">
		<button class="top-icon menu-toggle-button open-panel-b">☰</button>
		<div class="element-search hidden-lg-down" style="display: none">
			<input placeholder="Start typing to search..." type="text">
		</div>
		<div class="top-icon top-search hidden-xl-up" >
			<i class="os-icon os-icon-ui-37"></i>
		</div>
		<!--------------------
		START - Messages Link in secondary top menu
		-------------------->
		<div class="messages-notifications os-dropdown-trigger os-dropdown-center"
		     v-bind:class="{ over: showMessageDropdown }"
		     v-on:click="showMessageDropdown = !showMessageDropdown">
			<i class="os-icon os-icon-mail-14"></i>
			<div class="new-messages-count" v-if="session.unread_messages">
				{{ session.unread_messages }}
			</div>
			<div class="os-dropdown light message-list" v-on:mouseleave="showMessageDropdown = !showMessageDropdown">
				<div class="icon-w">
					<i class="os-icon os-icon-mail-14"></i>
				</div>
				<messagesWidget />
			</div>
		</div>
		<!--------------------
		END - Messages Link in secondary top menu
		--------------------><!--------------------
              START - User avatar and menu in secondary top menu
              -------------------->
		<div class="logged-user-w">
			<div class="logged-user-i">
				<div class="avatar-w">
					<img :src="'http://sp.co/api/v1/users/get/profile_pic/'+session.uid"/>
				</div>
				<div class="logged-user-menu">
					<div class="logged-user-avatar-info">
						<div class="avatar-w">
							<img :src="'http://sp.co/api/v1/users/get/profile_pic/'+session.uid"/>
						</div>
						<div class="logged-user-info-w">
							<div class="logged-user-name">
								{{ session.first_name }} {{ session.last_name }}
							</div>
							<div class="logged-user-role">
								@{{ session.username }}
							</div>
						</div>
					</div>
					<div class="bg-icon">
						<i class="os-icon os-icon-wallet-loaded"></i>
					</div>
					<ul>
						<li>
							<a href="#" v-on:click="sessionStop"><i class="os-icon os-icon-signs-11"></i><span>Logout</span></a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!--------------------
		END - User avatar and menu in secondary top menu
		-------------------->

		<!--------------------
              START - Settings Link in secondary top menu
              -------------------->
		<div class="top-icon open-panel-b" v-on:click="controlPanel()">
			<i class="ti-shift-left"></i>
		</div>
		<!--------------------
		END - Settings Link in secondary top menu
		-------------------->
	</div>
</template>
<script>
    import messagesWidget from '@/components/message/widget/messages'

    export default {
        name: 'dockTopMenu',
	    components: {messagesWidget},
        data () {
            return {
				showMessageDropdown: false,
	            session: this.$root.session
            }
        },
	    methods: {
        sessionStop () {
          this.$bus.$emit('globalLoader', true);
          this.$setItem('auth', {});
          window.location.href = '/';
        },
	    }
    }
</script>
<style scoped>
	.message-list {
		width: 350px;
		right: 260px;
	}

	@media only screen and (min-width: 1200px) {
		.open-panel-b {
			 display: none
		}
	}

</style>




// WEBPACK FOOTER //
// src/dockTopMenu.vue